import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GavelIcon from '@mui/icons-material/Gavel';
import WorkIcon from '@mui/icons-material/Work';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ContactsIcon from '@mui/icons-material/Contacts';
import PersonIcon from '@mui/icons-material/Person';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import SearchIcon from '@mui/icons-material/Search';

// Default tabs for GC/Owner
const defaultTabs = [
    { id: 'dashboard', label: 'Dashboard', path: '/dashboard', icon: DashboardIcon },
    { id: 1, label: 'Out for Bid', path: '/account/1', icon: GavelIcon },
    { id: 2, label: 'Active Projects', path: '/account/2', icon: WorkIcon },
    { id: 3, label: 'Schedule', path: '/account/3', icon: CalendarMonthIcon },
    { id: 4, label: 'My Contacts', path: '/account/4', icon: ContactsIcon },
    { id: 0, label: 'Profile', path: '/account/0', icon: PersonIcon }
];

// Tabs for Sub-Contractor
export const subContractorTabs = [
    { id: 'dashboard', label: 'Dashboard', path: '/dashboard', icon: DashboardIcon },
    { id: 1, label: 'Pending Projects', path: '/account/1', icon: HourglassEmptyIcon },
    { id: 2, label: 'Active Projects', path: '/account/2', icon: WorkIcon },
    { id: 3, label: 'Schedule', path: '/account/3', icon: CalendarMonthIcon },
    { id: 4, label: 'Find Project', path: '/account/4', icon: SearchIcon },
    { id: 0, label: 'Profile', path: '/account/0', icon: PersonIcon }
];

// Reusable welcome banner component
export function AccountWelcome() {
    const userData = useSelector((state) => {
        return state?.userProfileSlice?.userData?.data;
    });

    const firstName = userData?.fname || 'User';
    const displayName = firstName.length > 20 ? firstName.slice(0, 20) + '...' : firstName;

    return (
        <div className="account_header_top">
            <div className="container">
                <div className="header_content">
                    <h1>Welcome back, <span>{displayName}</span></h1>
                </div>
            </div>
        </div>
    );
}

// Reusable tabs component
export function AccountTabs({ tabs = defaultTabs, activeTab, onTabChange }) {
    const location = useLocation();
    
    // Determine active tab from URL if not provided
    const currentPath = location.pathname;
    const activeTabFromUrl = tabs.find(tab => currentPath === tab.path)?.id;
    const currentActiveTab = activeTab !== undefined ? activeTab : activeTabFromUrl;

    const handleTabClick = (tabId) => {
        if (onTabChange) {
            onTabChange(tabId);
        }
    };

    return (
        <div className="account_header_tabs">
            <div className="container">
                <nav className="account_nav">
                    <ul>
                        {tabs.map((tab) => {
                            const IconComponent = tab.icon;
                            return (
                                <li key={tab.id}>
                                    {onTabChange ? (
                                        <button
                                            onClick={() => handleTabClick(tab.id)}
                                            className={currentActiveTab === tab.id ? 'active' : ''}
                                        >
                                            {IconComponent && <IconComponent style={{ fontSize: 18, marginRight: 6, verticalAlign: 'middle' }} />}
                                            {tab.label}
                                        </button>
                                    ) : (
                                        <Link
                                            to={tab.path}
                                            className={currentActiveTab === tab.id ? 'active' : ''}
                                        >
                                            {IconComponent && <IconComponent style={{ fontSize: 18, marginRight: 6, verticalAlign: 'middle' }} />}
                                            {tab.label}
                                        </Link>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </div>
        </div>
    );
}

export default function AccountHeader({ activeTab, onTabChange, showTabs = true, tabs = defaultTabs }) {
    return (
        <section className="account_header">
            <AccountWelcome />
            {showTabs && (
                <AccountTabs tabs={tabs} activeTab={activeTab} onTabChange={onTabChange} />
            )}
        </section>
    );
}
